const SectionSingleSeatDrag = {
  order: 0,
  activate: "seats:mode:drag",
  run($$) {
    $$.$.on("seats:rendered", () => {
      $$.$arena.find(".seats-container > [data-type]").draggable({
        containment: "parent",
        distance: 4,
        grid: [$$.SEAT_WIDTH, $$.SEAT_HEIGHT],
        snap: ".h-ruler",
      });
    });
  },
};

window.SectionSingleSeatDrag = SectionSingleSeatDrag;

export default SectionSingleSeatDrag;
